import baseApi, { TAGS } from './baseApi';

const agentChatApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgentChatHistory: builder.query({
      query: ({ userId, taxYear }) => ({
        url: '../ops-system/agent-chat-history',
        params: { userId, taxYear },
        method: 'GET'
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.AGENT_CHAT_HISTORY]
    })
  })
});

export const { useGetAgentChatHistoryQuery } = agentChatApi;
